export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-en-SG.38afc08c.xlsx";